import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'dmp_alarms'

// The units branch (dmp_panels → cameras_proxy → units_cameras → units) answers
// Internal Server Error for any units/regions/municipalities column — the branch
// chain in the backend dataset definition is broken — so installation, estado
// and municipio are not offered. sectors/centers join directly off dmp_panels
// and do work. view_camera_name resolves null on every row (panels carry no
// camera proxy in the data), so the camera filter is left out too.
const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: false,                           // units branch: 500 server-side
  REGION: false,                                 // units branch: 500 server-side
  MUNICIPALITY: false,                           // units branch: 500 server-side
  SECTOR: {},                                    // sectors.name (via dmp_panels.id_sector)
  CENTER: {},                                    // centers.name (via dmp_panels.id_center)
  TENANT: {},                                    // tenants.name (via dmp_servers.id_tenant)
  STATUS: { column: 'view_alarm_status.alarm_status', label: 'Estatus' },
  USER: false,                                   // no users join
})

export default {
  key: DATASET_KEY,
  label: 'Alarmas DMP',
  timeColumn: 'dmp_alarms.event_created_at',
  permission: { action: 'read', subject: 'Dmp' },

  tables: {
    dmp_alarms: ["id", "event_id", "event_definition", "event_type", "device_type", "device_id", "device_name", "user_id", "user_name", "description", "event_created_at", "id_alarm", "id_dmp_panel", "id_type_alarm", "created_at", "updated_at"],
    type_alarms: ["id", "type", "description"],
    view_alarm_status: ["id_alarm", "alarm_status"],
    dmp_panels: ["id", "name", "id_sector", "id_center", "id_dmp_server"],
    dmp_servers: ["id", "name", "id_tenant"],
    sectors: ["id", "id_center", "name"],
    centers: ["id", "name"],
    tenants: ["id", "name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'type_alarms.description',
  },

  csvConfig: {
    columns: 'dmp_alarms.event_created_at,type_alarms.description,dmp_alarms.event_definition,dmp_alarms.event_type,dmp_alarms.device_type,dmp_alarms.device_id,dmp_alarms.device_name,dmp_alarms.user_name,dmp_alarms.description,view_alarm_status.alarm_status,dmp_panels.name,sectors.name,centers.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'type_alarms.description', label: 'Tipo' },
    { key: 'dmp_alarms.device_type', label: 'Tipo de dispositivo' },
    { key: 'dmp_alarms.device_name', label: 'Dispositivo' },
    { key: 'dmp_panels.name', label: 'Panel' },
    { key: 'view_alarm_status.alarm_status', label: 'Estatus' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'dmp_alarms.event_created_at', label: 'Fecha del evento', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'type_alarms.description', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'dmp_alarms.device_name', 'Dispositivo', 'name'),
    embedFilter(DATASET_KEY, 'dmp_alarms.device_type', 'Tipo de dispositivo', 'device_type'),
    // event_definition / event_type are the raw DMP codes (Za, Zq… / BU, SV…),
    // the same values the /#/dmp views filter by — offered as filters only.
    embedFilter(DATASET_KEY, 'dmp_alarms.event_definition', 'Definición de evento', 'event_definition'),
    embedFilter(DATASET_KEY, 'dmp_alarms.event_type', 'Tipo de evento', 'event_type'),
    embedFilter(DATASET_KEY, 'dmp_panels.name', 'Panel', 'group'),
  ],

  dateGrouping: {
    column: 'dmp_alarms.event_created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
